import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import NavBarAuth from "../../../../components/navbar/navbarAuth";
import { RxCrossCircled } from "react-icons/rx";
import { BaseURL } from "../../../../Files/BaseURL";
import AlertContext from "../../../../Context/Alert/AlertContext";

function Industry() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [IndustryList, setIndustryList] = useState([]);
  const [ServiceSelect, setServiceSelect] = useState(null);
  const [ServiceSkill, setServiceSkill] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const [skills, setskills] = useState([]);
  const [skilldata, setskilldata] = useState("");

  const [errors, setErrors] = useState({
    industry: "",
    skills: "",
  });

  const fetchIndustry = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/auth/servicecategoryname`);
      const data = await response.json();
      setIndustryList(data);
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  useEffect(() => {
    fetchIndustry();
  }, []);

  const fetchServiceSkills = async () => {
    try {
      const response = await fetch(
        `${BaseURL}/api/auth/servicecategoryDetail/${ServiceSelect}`,
        {
          headers: {
            AdminODSToken: sessionStorage.getItem("token"),
          },
        }
      );
      const data = await response.json();
      const subSkills = [];

      data.Skills.forEach((skill) => {
        skill.subSkill.forEach((sub) => {
          subSkills.push(sub);
        });
      });
      setServiceSkill(subSkills);
    } catch (error) {
      showAlert("Error fetching Services", "danger");
    }
  };

  useEffect(() => {
    if (ServiceSelect) {
      fetchServiceSkills();
    }
  }, [ServiceSelect]);

  const validateForm = () => {
    const newErrors = {};

    if (!ServiceSelect) {
      newErrors.industry = "Please select an industry";
    }

    if (skills.length === 0) {
      newErrors.skills = "Please select at least one skill";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateSkill = async () => {
    if (!validateForm()) {
      showAlert("Please fill all required fields", "danger");
      return;
    }

    try {
      setIsLoading(true);
      const response = await fetch(`${BaseURL}/api/auth/createSkill/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Industry: ServiceSelect,
          Skills: skills.map((skill) => ({ skill: skill._id })),
        }),
      });

      const data = await response.json();

      if (response.ok) {
        navigate(`/verifictation/${id}`);
      } else {
        showAlert(data.message || "Error creating skills", "danger");
        setIsLoading(false);
      }
    } catch (error) {
      showAlert(error.message || "Error creating skills", "danger");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <>
      <NavBarAuth />
      <div className="bg-gray-100">
        <div className="w-[100%] h-2 bg-primarygreen rounded-r-full"></div>
      </div>
      <div className="flex justify-center items-center bg-gray-100 py-20">
        <div className="mx-6 w-[95%] md:w-[60%] lg:w-[40%] bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-pop font-bold mb-4">Your industry</h2>
          <div className="mb-4">
            <select
              name="industry"
              id="industry"
              value={ServiceSelect || ""}
              onChange={(e) => {
                setServiceSelect(e.target.value);
                setErrors((prev) => ({ ...prev, industry: "" }));
              }}
              className={`w-full px-6 border-2 ${
                errors.industry ? "border-red-500" : "border-transparent"
              } font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
            >
              <option value="">Select Industry</option>
              {IndustryList?.map((item, index) => (
                <option value={item._id} key={index}>
                  {item.name}
                </option>
              ))}
            </select>
            {errors.industry && (
              <p className="text-red-500 text-sm mt-1 ml-4">
                {errors.industry}
              </p>
            )}
          </div>

          <p className="text-gray-600 font-pop mb-2 max-w-sm">
            Choose skills most suitable for you:
          </p>
          <div className="mb-4">
            <select
              name="skills"
              id="skills"
              value={skilldata}
              onChange={(e) => {
                const selectedSkill = ServiceSkill.find(
                  (skill) => skill._id === e.target.value
                );
                if (selectedSkill) {
                  setskills((prevSkills) => [...prevSkills, selectedSkill]);
                  setskilldata("");
                  setErrors((prev) => ({ ...prev, skills: "" }));
                }
              }}
              className={`w-full px-6 border-2 ${
                errors.skills ? "border-red-500" : "border-transparent"
              } font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
              disabled={!ServiceSelect}
            >
              <option value="">Select Skills</option>
              {ServiceSkill?.map((item, index) => (
                <option value={item._id} key={index}>
                  {item.name}
                </option>
              ))}
            </select>
            {errors.skills && (
              <p className="text-red-500 text-sm mt-1 ml-4">{errors.skills}</p>
            )}
          </div>

          <div className="mb-4 grid md:grid-cols-2 grid-cols-1 gap-2">
            {skills.map((item, index) => (
              <div
                className="bg-primarygreen/50 items-center text-base font-pop rounded-2xl py-2 px-6 flex justify-between"
                key={index}
              >
                <p>{item.name}</p>
                <RxCrossCircled
                  className="cursor-pointer hover:text-red-500 transition-colors"
                  onClick={() => {
                    setskills((prevSkills) =>
                      prevSkills.filter((skill) => skill._id !== item._id)
                    );
                  }}
                />
              </div>
            ))}
          </div>

          <button
            onClick={handleCreateSkill}
            disabled={isLoading}
            className={`${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            } my-4 w-full bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp`}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              </div>
            ) : (
              "Create Skills"
            )}
          </button>
        </div>
      </div>
    </>
  );
}

export default Industry;
